import { watch } from 'vue';

const STORAGE_KEY = 'statistics_timezone';

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
export default () => {
  const storedTimezone = localStorage.getItem(STORAGE_KEY);

  const savedTimezone = storedTimezone?.startsWith('Etc/GMT') ? storedTimezone : 'Etc/GMT+0';

  const watchTimezone = (getter: () => string | null): void => {
    watch(getter, (value) => {
      if (value) {
        localStorage.setItem(STORAGE_KEY, value);
      } else {
        localStorage.removeItem(STORAGE_KEY);
      }
    });
  };

  return {
    savedTimezone,
    watchTimezone,
  };
};
